import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class LoginEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  post(credentials: Auth.AuthPostRequest) {
    return this.httpClient
      .post<Auth.AuthPostResponse>(`${this.env.constants.API_URL}/users/me/authenticate`, credentials)
  }

  // removes token
  delete() {
    return this.httpClient
      .delete<void>(`${this.env.constants.API_URL}/users/me/authenticate`)
  }
}
